export default "/assets/scale.svg";